module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/ja-合作.49c14567.png";